import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyPolicyModal({
  isOpen,
  onClose
}: PrivacyPolicyModalProps) {
  if (!isOpen) return null;
  return <AnimatePresence data-id="element-114">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-115" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-116">
            <div className="flex min-h-full items-center justify-center p-4" data-id="element-117">
              <motion.div initial={{
            opacity: 0,
            scale: 0.95,
            y: 20
          }} animate={{
            opacity: 1,
            scale: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.95,
            y: 20
          }} className="relative bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[80vh] overflow-hidden" data-id="element-118">
                {/* Header */}
                <div className="sticky top-0 bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between" data-id="element-119">
                  <h2 className="text-2xl font-bold text-slate-900" data-id="element-120">
                    Privacy Policy
                  </h2>
                  <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-full transition-colors" data-id="element-121">
                    <XIcon className="w-5 h-5 text-slate-600" data-id="element-122" />
                  </button>
                </div>

                {/* Content */}
                <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-123">
                  <p className="text-sm text-slate-600 mb-6" data-id="element-124">
                    Effective Date: {new Date().toLocaleDateString()}
                  </p>

                  <section className="mb-6" data-id="element-125">
                    <h3 className="text-lg font-bold text-slate-900 mb-3" data-id="element-126">
                      1. INTRODUCTION
                    </h3>
                    <p className="text-slate-700 leading-relaxed" data-id="element-127">
                      At Consejos Simples, we respect your privacy and are
                      committed to protecting your personal data. This Privacy
                      Policy explains how we collect, use, and safeguard your
                      information when you purchase the "Nail Biz Blueprint" or
                      visit our website.
                    </p>
                  </section>

                  <section className="mb-6" data-id="element-128">
                    <h3 className="text-lg font-bold text-slate-900 mb-3" data-id="element-129">
                      2. INFORMATION WE COLLECT
                    </h3>
                    <ul className="list-disc pl-5 space-y-2 text-slate-700" data-id="element-130">
                      <li data-id="element-131">
                        <strong data-id="element-132">Identity Data:</strong> Name and email address
                        provided during purchase.
                      </li>
                      <li data-id="element-133">
                        <strong data-id="element-134">Transaction Data:</strong> Details about
                        payments (processed securely via Stripe/PayPal/Hotmart).
                        We do not store your credit card numbers on our servers.
                      </li>
                      <li data-id="element-135">
                        <strong data-id="element-136">Technical Data:</strong> IP address and browser
                        type through cookies to improve user experience.
                      </li>
                    </ul>
                  </section>

                  <section className="mb-6" data-id="element-137">
                    <h3 className="text-lg font-bold text-slate-900 mb-3" data-id="element-138">
                      3. HOW WE USE YOUR DATA
                    </h3>
                    <p className="text-slate-700 mb-2" data-id="element-139">We use your data to:</p>
                    <ul className="list-disc pl-5 space-y-2 text-slate-700" data-id="element-140">
                      <li data-id="element-141">Deliver your digital product and bonuses.</li>
                      <li data-id="element-142">Provide customer support.</li>
                      <li data-id="element-143">
                        Send you marketing emails (you can unsubscribe at any
                        time).
                      </li>
                      <li data-id="element-144">Comply with legal obligations in the USA.</li>
                    </ul>
                  </section>

                  <section className="mb-6" data-id="element-145">
                    <h3 className="text-lg font-bold text-slate-900 mb-3" data-id="element-146">
                      4. DATA SECURITY
                    </h3>
                    <p className="text-slate-700 leading-relaxed" data-id="element-147">
                      We implement industry-standard security measures (SSL
                      encryption) to prevent your personal data from being
                      accidentally lost, used, or accessed in an unauthorized
                      way.
                    </p>
                  </section>

                  <section className="mb-6" data-id="element-148">
                    <h3 className="text-lg font-bold text-slate-900 mb-3" data-id="element-149">
                      5. THIRD-PARTY LINKS
                    </h3>
                    <p className="text-slate-700 leading-relaxed" data-id="element-150">
                      Our site may include links to third-party websites (like
                      Amazon for the Starter Kit). We are not responsible for
                      their privacy statements.
                    </p>
                  </section>

                  <section className="mb-6" data-id="element-151">
                    <h3 className="text-lg font-bold text-slate-900 mb-3" data-id="element-152">
                      6. YOUR RIGHTS
                    </h3>
                    <p className="text-slate-700 leading-relaxed" data-id="element-153">
                      Depending on your state (e.g., CCPA in California), you
                      have the right to request access to or deletion of your
                      personal data. Contact us at: consejossimples@gmail.com
                    </p>
                  </section>
                </div>
              </motion.div>
            </div>
          </div>
        </>}
    </AnimatePresence>;
}